import script from "./audio_controls.vue?vue&type=script&setup=true&lang=js"
export * from "./audio_controls.vue?vue&type=script&setup=true&lang=js"

import "./audio_controls.vue?vue&type=style&index=0&id=690b4ed8&lang=scss"

const __exports__ = script;

export default __exports__